import React, { Component } from "react";
import client from "@culturehq/client";
import { useLazyImport } from "@culturehq/hooks";

import { Trans } from "app/utils";

import ErrorModal from "components/display/ErrorModal";

import StoryPromptOption from "./StoryPromptOption";

class StoryPromptOptionsInner extends Component {
  promptsRef = React.createRef();

  constructor(props) {
    super(props);

    const { prompts } = this.props;

    this.state = {
      prompts: prompts || [],
      error: null
    };
  }

  componentDidMount() {
    const { Sortable } = this.props;

    this.sortable = new Sortable(this.promptsRef.current, {
      handle: ".sortable__drag-handler",
      onEnd: this.handleSort
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { prompts } = this.props;
    if (prompts && prompts.length !== prevState.prompts.length) {
      this.setState({ prompts });
    }
  }

  handleSort = async event => {
    this.sortable.option("disabled", true);

    const { prompts } = this.state;
    const promptElements = Array.from(event.to.children);

    promptElements.forEach((optionElement, position) => {
      const identifier = optionElement.getAttribute("data-id");
      const found = prompts.find(
        ({ id, key }) => (id || key).toString() === identifier
      );
      found.position = position;
    });

    this.setState({ prompts });
    this.handleChange();
    this.sortable.option("disabled", false);
  };

  handleDelete = async index => {
    const { prompts } = this.state;
    const { onDelete } = this.props;

    const newPrompts = prompts;
    newPrompts.splice(index, 1);
    this.setState({ prompts: newPrompts });
    // onDelete(index);
  };

  handleChange = () => {
    const { onChange } = this.props;
    const { prompts } = this.state;

    if (onChange) {
      onChange(prompts);
    }
  };

  handleUpdate = subprompt => {
    const { prompts } = this.state;
    const { onUpdate } = this.props;

    const newPrompts = prompts;
    newPrompts[subprompt.index] = subprompt;
    this.setState({ prompts: newPrompts });
    onUpdate(newPrompts);
  };

  render() {
    const { error } = this.state;
    let { prompts = [] } = this.state;

    prompts = prompts.sort(
      (optionA, optionB) => optionA.position - optionB.position
    );

    return (
      <>
        <div className="chart">
          <div className="row chart-header">
            <div className="col-sm-7 p-0 prompt-title-header">
              <Trans>Prompt</Trans>
            </div>
            <div className="col-sm-4">
              <Trans>Media Types Allowed</Trans>
            </div>
          </div>
          <div ref={this.promptsRef}>
            {prompts.map((prompt, index) => (
              <StoryPromptOption
                key={prompt.key || prompt.id}
                prompt={prompt}
                onDelete={this.handleDelete}
                onUpdate={this.handleUpdate}
                index={index}
              />
            ))}
          </div>
          <ErrorModal error={error} />
        </div>
      </>
    );
  }
}

const StoryPromptOptions = props => {
  const Sortable = useLazyImport(() => import("sortablejs"));

  return Sortable ? <StoryPromptOptionsInner {...props} Sortable={Sortable} /> : null;
};

export default StoryPromptOptions;
